/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const getSiteWideBannerData = (data) => {
    const bannerDataBottom = [];
    const bannerDataTop = [];
    // hijacks "sitewide_banner_v2" and renders multi offer banner in HeaderBannersList Switch
    let isMultiBannerEnabled = false;

    data.forEach((element) => {
        if (element.use_as_eyebrow) {
            element.reference.forEach((block) => {
                bannerDataTop.push(block);
            });
        } else {
            element.reference.forEach((block) => {
                bannerDataBottom.push(block);
                // hijacks "sitewide_banner_v2" and renders multi offer banner in HeaderBannersList Switch
                if (element.use_multibaner && block?._content_type_uid === 'sitewide_banner_v2') {
                    isMultiBannerEnabled = true;
                }
            });
        }
    });

    return {
        bannerDataBottom, bannerDataTop, isMultiBannerEnabled,
    };
};

export default {};
